<div class="container">
  <div class='contain'>
    <div class="loading">Please wait...</div>
    <div class="svg-animation">
      <div class="spinner" image-loader="assets/imgs/loading.gif"></div>
    </div>
  </div>
</div>